const serviceUnavailableMsg = 'This service is temporarily unavailable.';
const pleaseTryAgainMsg = 'Please try again in a few minutes or use the green chat button to the right to reach a representative.';
const contactSystemSupportMsg = 'Please try again in a few minutes. If this message persists, contact system support.'
const errorText = 'error';
const reports = 'reports';
const agencyManagement = 'agency management';
const addUsername = 'Add username';
const marketing = 'marketing'
const WANTTOMENULINK = 'WantToMenuLink';
const AGENTTOOLS = 'AgentTools';
const GETHELP = 'GetHelp';
const AMSUITE_PC = 'AMsuite';
const NAVTILELINK = 'NavTileLink';
const QUICKLINK = 'QuickLink';
const amsuite = 'amsuite';
const goToAmsuite= 'go to amsuite';
const policyDocumentsPortal = 'policy documents portal';
const agency = 'agency';
const advancedSearch = 'advancedSearch';
const changeLoginId = 'changeLoginId';
const restrict = 'restrict';
const remove = 'remove';
const expire = 'expire';
const restrictModal = 'restrict-modal';
const commonModal = 'common-modal';
const mobileModal = 'mobile-modal';
const commonModalContainer = 'common-modal-container';
const iWantTo = 'I want to';
const agentTools = 'Agent tools';
const getHelp = 'Get help';
const separator = 'separator';
const logout = 'Log out';
const accountPreferences = 'Account preferences';
const activeUser = 'active-user';
const notifications = 'Notifications';
const notification = 'notification';
const account = 'account';
const updateUsername = 'Update username';
const agent = 'agent';
const petHealth = 'pet health';

const constants = {
  serviceUnavailableMsg,
  pleaseTryAgainMsg,
  contactSystemSupportMsg,
  errorText,
  reports,
  agencyManagement,
  marketing,
  WANTTOMENULINK,
  GETHELP,
  AGENTTOOLS,
  AMSUITE_PC,
  NAVTILELINK,
  QUICKLINK,
  amsuite,
  addUsername,
  goToAmsuite,
  policyDocumentsPortal,
  agency,
  advancedSearch,
  changeLoginId,
  restrict,
  remove,
  expire,
  restrictModal,
  commonModal,
  mobileModal,
  commonModalContainer,
  iWantTo,
  agentTools,
  getHelp,
  separator,
  logout,
  accountPreferences,
  activeUser,
  notifications,
  notification,
  account,
  updateUsername,
  agent,
  petHealth
};

export default constants;
